module.exports = __webpack_public_path__ + "img/gy_pic_none@2x.8531403c.png";